import { Injectable } from '@angular/core';
import { PatientAppIframeCommunicationService } from '@modules/patient/services/patient-app-iframe-communication.service';
import { PatientQuery } from '@modules/patient/state/patient-query';
import { ShellQuery } from '@shared/store/shell/shell-query';
import { combineLatest, Observable, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';

@Injectable()
export class RxIntuitivePatientDetailsFacade {
	constructor(
		private readonly shellQuery: ShellQuery,
		private readonly patientQuery: PatientQuery,
		private readonly patientAppIframeCommunicationService: PatientAppIframeCommunicationService
	) {}

	validatePatientDetailsForSave(): Observable<boolean> {
		if (this.shellQuery.isReadOnly) {
			return of(true);
		}

		return combineLatest([this.patientQuery.patient$, this.patientQuery.isPatientInConflict$]).pipe(
			map(([patient, isPatientInConflict]) => {
				const isPatientDetailsValidForSave = !!patient && !isPatientInConflict;

				return isPatientDetailsValidForSave;
			})
		);
	}

	savePatientDetails(): Observable<boolean> {
		return this.validatePatientDetailsForSave().pipe(
			take(1),
			switchMap(isPatientAppValid => {
				if (
					isPatientAppValid &&
					!this.shellQuery.isReadOnly &&
					this.patientQuery.isPatientAppConfigured &&
					!this.patientQuery.patientGuid
				) {
					return this.patientAppIframeCommunicationService.savePatient().pipe(take(1));
				}

				return of(isPatientAppValid);
			})
		);
	}
}
